module.exports = __webpack_public_path__ + "img/db_1@2x.daec8fee.png";